import { useTheme } from '@/hooks/useTheme';
import { useTranslation } from 'react-i18next';
import { secondaryMetrics, financialStrip, formatMoneyShort } from '@/mocks/ownerDashboard';

export default function SecondaryAndFinancial() {
  const { isDark } = useTheme();
  const { t } = useTranslation();

  const cardBg = isDark ? '#1A1A1A' : '#FFFFFF';
  const cardBorder = isDark ? 'rgba(255,255,255,0.07)' : '#E5E5E8';
  const textMain = isDark ? '#E0E0E0' : '#1A1A1A';
  const textMuted = '#6B6B70';
  const textDim = isDark ? '#4A4A50' : '#9B9BA4';

  return (
    <>
      {/* Section 5: Secondary muted row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5" style={{ opacity: 0.75 }}>
        <div
          className="rounded-xl p-4"
          style={{ background: cardBg, border: `1px solid ${cardBorder}` }}
        >
          <div className="flex items-center gap-2">
            <span style={{ fontSize: 14 }}>⚖️</span>
            <span className="text-sm font-semibold" style={{ color: textMain, fontFamily: 'Muller, Inter, sans-serif' }}>
              {t('d_sec_imbalance')}: −{formatMoneyShort(Math.abs(secondaryMetrics.imbalance))} {t('d_u_uah')}
            </span>
          </div>
          <div className="text-[10px] mt-1 ml-7" style={{ color: textDim, fontFamily: 'Muller, Inter, sans-serif' }}>
            {t('d_sec_imbalance_sub')}
          </div>
        </div>

        <div
          className="rounded-xl p-4"
          style={{ background: cardBg, border: `1px solid ${cardBorder}` }}
        >
          <div className="flex items-center gap-2">
            <span style={{ fontSize: 14 }}>🔋</span>
            <span className="text-sm font-semibold" style={{ color: '#0D7A3C', fontFamily: 'Muller, Inter, sans-serif' }}>
              {t('d_sec_bess')}: +{formatMoneyShort(secondaryMetrics.bessArbitrage)} {t('d_u_uah')}
            </span>
          </div>
          <div className="text-[10px] mt-1 ml-7" style={{ color: textDim, fontFamily: 'Muller, Inter, sans-serif' }}>
            {t('d_sec_bess_sub')}
          </div>
        </div>
      </div>

      {/* Section 6: Financial strip */}
      <div
        className="rounded-xl px-4 py-3 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-5"
        style={{ background: cardBg, border: `1px solid ${cardBorder}` }}
      >
        <div className="flex items-center gap-3 flex-wrap">
          <span className="text-sm font-semibold whitespace-nowrap" style={{ color: textMain, fontFamily: 'Muller, Inter, sans-serif' }}>
            {t('d_sec_settlements_with')} {financialStrip.offtaker} ({t('d_sec_offtaker')})
          </span>
          <span className="text-xs" style={{ color: textDim, fontFamily: 'Muller, Inter, sans-serif' }}>·</span>
          <span className="text-xs whitespace-nowrap" style={{ color: textMuted, fontFamily: 'Muller, Inter, sans-serif' }}>
            {t('d_sec_receivables')}: {formatMoneyShort(financialStrip.receivables)} {t('d_u_uah')} · {t('d_sec_payment_due')} {financialStrip.paymentDue}
          </span>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-[10px]" style={{ color: textDim, fontFamily: 'Muller, Inter, sans-serif' }}>
            {financialStrip.contractNote}
          </span>
          <button
            className="px-4 py-1.5 rounded-md text-xs font-semibold cursor-pointer transition-colors whitespace-nowrap"
            style={{
              background: 'transparent',
              border: `1px solid ${cardBorder}`,
              color: textMain,
              fontFamily: 'Muller, Inter, sans-serif',
            }}
          >
            {t('d_sec_reports')}
          </button>
        </div>
      </div>
    </>
  );
}